<template>
  <div
    class="overlay-out-sidebar"
    :class="{'-visible': sidebarVisible}"
    @click="hideSidebar"
  ></div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'OverlayOutSidebar',

  methods: {
    ...mapMutations('dashboard', [
      'hideSidebar',
    ]),
  },

  computed: {
    ...mapState('dashboard', [
      'sidebarVisible',
    ]),
  },
};
</script>

<style lang="scss" scoped>
  .overlay-out-sidebar {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
    display: none;
    background-color: rgba(0,0,0,.6);
    height: 100vh;

    &.-visible {
      display: block;

      @media (min-width: 768px) {
        display: none;
      }
    }
  }
</style>
